<section class="jhd-container">

    <!-- Page Header -->
    <header class="jhd-page-header">
        <button class="jhd-back-btn" (click)="backToJobHistory()">
            <ng-container *ngComponentOutlet="icons.arrowLeft"></ng-container>
            <span>Back</span>
        </button>
        <h1 class="jhd-page-title">Associate Details</h1>
        <div class="jhd-header-actions">
            <app-download-button [tableValues]="exportData"
                (buttonClicked)="downloadBtnOnClick($event)"></app-download-button>
        </div>
    </header>

    <!-- Note Bar -->
    <!-- <div class="jhd-note-bar">
        <span class="jhd-note-label">Note:</span>
        <span>Tenure displayed in Months</span>
    </div> -->

    <!-- Content -->
    <div class="jhd-content">
        <mat-accordion multi>
            @for(associateInfo of associateDetails; track idx; let idx = $index) {

            <mat-expansion-panel [expanded]="true" class="jhd-brand-panel">
                <div class="jhd-note-bar">
                    <span class="jhd-note-label">Note:</span>
                    <span>Tenure displayed in Months</span>
                </div>

                <!-- Brand / Org Panel Header -->
                @if(associateInfo['headerLabel']) {
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="jhd-org-header-content">
                            <div class="jhd-icon-wrap jhd-org-icon-wrap">
                                <ng-container *ngComponentOutlet="icons.building"></ng-container>
                            </div>
                            <div class="jhd-org-info">
                                <span class="jhd-org-label">Organization</span>
                                <span class="jhd-org-name">{{associateInfo['headerLabel']}}</span>
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                }

                <!-- Flat Table Sections -->
                @for(tableSchema of associateInfo['tableSchemaArray']; track idx1; let idx1 = $index) {
                <div class="jhd-section-block">
                    @if(tableSchema['title']) {
                    <div class="jhd-section-header">
                        <span class="jhd-icon-wrap jhd-section-icon-wrap">
                            @if(tableSchema['title'] === 'Associate Summary') {
                            <ng-container *ngComponentOutlet="icons.users"></ng-container>
                            } @else if(tableSchema['title'] === 'Dealer Status') {
                            <ng-container *ngComponentOutlet="icons.building"></ng-container>
                            } @else if(tableSchema['title'] === 'Primary Job Enrollment Status') {
                            <ng-container *ngComponentOutlet="icons.briefcase"></ng-container>
                            } @else if(tableSchema['title'] === 'Secondary Job Roles') {
                            <ng-container *ngComponentOutlet="icons.briefcase"></ng-container>
                            } @else if(tableSchema['title'] === 'Certification Details') {
                            <ng-container *ngComponentOutlet="icons.award"></ng-container>
                            } @else {
                            <ng-container *ngComponentOutlet="icons.layoutList"></ng-container>
                            }
                        </span>
                        <span class="jhd-section-title">{{tableSchema['title']}}</span>
                    </div>
                    }
                    <div class="jhd-table-area">
                        <app-dynamic-data-table [DataTableSchema]="tableSchema['schema']"
                            [dataInput]="tableSchema['schema']['dataSource'].length > 0 ? tableSchema['schema']['dataSource'] : []">
                        </app-dynamic-data-table>
                    </div>
                </div>
                }

            </mat-expansion-panel>

            }
        </mat-accordion>
    </div>

</section>